import * as React from "react";
import { AppStore } from "../Stores/AppStore";
import { Urls } from "../Urls";
import { Area } from "../General/Area";
import { AreaBody } from "../General/AreaBody";
import { Toolbar } from "../General/Toolbar";
import { CloseButton } from "../Buttons/CloseButton";

export class About extends React.Component<{}, {}> {

	handleCancel = () => {
		AppStore.keepOnPage(Urls.home);
	}

	render() {
		return <Area>
			<AreaBody>
				<Toolbar>
					<span className="buttongroup is--buttongroup-right">
						<CloseButton onClick={this.handleCancel} testId="closeButton" />
					</span>
				</Toolbar>
				<div className="area-grid__body-content">
					<div className="content-main">
						<h1>About Noxum Secure Infoportal</h1>
						<p>Version: {AppStore.context.version}</p>
						<p>Manufacturer: <a href="https://www.noxum.com" target="_blank">Noxum GmbH</a></p>
						<p>Copyright: © {new Date().getFullYear()} Noxum GmbH</p>
					</div>
				</div>
			</AreaBody>
		</Area>;
	}
}